import FlightCheckInDetails from "./flight-check-in-details";
export default FlightCheckInDetails;